import {Directive, ElementRef, AfterViewInit, Input} from '@angular/core';

@Directive({
  selector: '[scroll-to]'
})
export class ScrollToDirective implements AfterViewInit {
  @Input('scroll-to') element?: string;

  constructor(private elRef:ElementRef) {}

  ngAfterViewInit() {
    const el = this.element ? document.querySelector(`.${this.element}`) : this.elRef.nativeElement;

    el.scrollIntoView({block: 'center', behavior: 'smooth'});
  }
}
